import { Modal, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Apis from '../../../../api';
import HSButton from '../../../common/Button';
import NormalInput from '../../../common/NormalInput';
import MessageActions from '../../../message/redux/actions';
import { Deal } from '../redux/types';

type Props = {
    type?: 'Enquiry specific to this deal' | 'General enquiry';
    open: boolean;
    deal?: Deal;
    setOpen: (f: boolean) => void;
};

const { TextArea } = Input;

const ContactUsModal: React.FC<Props> = ({ type, open, setOpen, deal }) => {
    const dispatch = useDispatch();

    const [selectedType, setType] = useState<'Enquiry specific to this deal' | 'General enquiry' | undefined>(
        undefined,
    );
    const [message, setMessage] = useState('');
    const [isValidate, setValidate] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (type) {
            setType(type);
        }
    }, [type, open]);

    const onClickCancel = () => {
        setOpen(false);
        setType(undefined);
        setMessage('');
        setValidate(false);
    };

    const onSubmit = () => {
        setValidate(true);
        if (message.trim() === '') {
            return;
        }
        setValidate(false);
        if (deal && selectedType === 'Enquiry specific to this deal') {
            setLoading(true);
            Apis.dealContactUs(deal.uuid, {
                message: message,
            })
                .then(() => {
                    dispatch(
                        MessageActions.showMessage({
                            error: false,
                            text: 'Thanks for your enquiry. Our Team will follow-up with you',
                        }),
                    );
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
                })
                .finally(() => {
                    setLoading(false);
                    onClickCancel();
                });
            return;
        }
        setLoading(true);
        Apis.generalContactUs({
            message: message,
        })
            .then(() => {
                dispatch(
                    MessageActions.showMessage({
                        error: false,
                        text: 'Thanks for your enquiry. Our Team will follow-up with you',
                    }),
                );
            })
            .catch((err) => {
                dispatch(MessageActions.showMessage({ error: true, text: String(err) }));
            })
            .finally(() => {
                setLoading(false);
                onClickCancel();
            });
    };
    return (
        <Modal
            open={open}
            title={
                selectedType === undefined
                    ? 'Enquiry Type'
                    : selectedType === 'Enquiry specific to this deal'
                    ? 'Deal Enquiry'
                    : 'General enquiry'
            }
            footer={null}
            onCancel={onClickCancel}
            onOk={onClickCancel}
            centered
        >
            {deal && selectedType === undefined && (
                <div className="flex flex-col justify-center items-center md:flex-row">
                    <HSButton
                        title="Enquiry specific to this deal"
                        className="mr-4"
                        onClick={() => setType('Enquiry specific to this deal')}
                    />
                    <HSButton
                        title="General enquiry"
                        onClick={() => setType('General enquiry')}
                        className=" mt-4 md:mt-0"
                    />
                </div>
            )}

            {selectedType !== undefined && (
                <div>
                    <div className="w-full">
                        {deal && selectedType === 'Enquiry specific to this deal' && (
                            <NormalInput
                                title="Deal Name"
                                disabled
                                value={deal.info.summary?.title}
                                name="deal"
                                onChange={() => {}}
                            />
                        )}
                        <div className="common_normalInput">
                            <label>Message*</label>
                            <TextArea rows={4} value={message} onChange={(e) => setMessage(e.target.value)} />
                            {isValidate && message.trim() === '' && (
                                <span className="common_error">Please enter message</span>
                            )}
                        </div>
                        <div className="flex justify-end mt-5">
                            <HSButton title="Submit" onClick={onSubmit} loading={loading} />
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    );
};
export default ContactUsModal;
